import { format } from "date-fns";
import { TruncatedText } from "@/components/ui/truncated-text";
import type { ABTest } from "@/types/ab-tests";

interface TestMetaRowProps {
  test: ABTest;
}

export function TestMetaRow({ test }: TestMetaRowProps) {
  return (
    <div className="grid grid-cols-3 gap-4 bg-muted/50 rounded-md p-3.5">
      <div className="space-y-1">
        <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">Created by</p>
        <p className="text-sm text-foreground font-semibold">
          <TruncatedText>{test.createdBy ?? "—"}</TruncatedText>
        </p>
      </div>
      <div className="space-y-1">
        <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">Started</p>
        <p className="text-sm text-foreground font-semibold">
          {test.startedAt ? format(new Date(test.startedAt), "MMM d, yyyy") : test.startDate ?? "—"}
        </p>
      </div>
      <div className="space-y-1">
        <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">Stopped</p>
        <p className="text-sm text-foreground font-semibold">
          {test.stoppedAt ? format(new Date(test.stoppedAt), "MMM d, yyyy") : test.endDate ?? "—"}
        </p>
      </div>
    </div>
  );
}
